import React from 'react'
import PropTypes from 'prop-types'
import { PnkProvider } from '../pnk-react/pnk-miniredux';
import { pnkstore } from "../stores/pnk-store";

import { Pnk_Error_Ctrl } from '../pnk-react/errors/error-ctrl'
import {
    BrowserRouter,
    Route,
    Switch
} from 'react-router-dom'

import { HomeContainer } from "../components/Home";
import { ForgotPasswordContainer } from "../components/Forgot";
import { LoginContainer } from "../components/Login";
import { SignUpContainer } from "../components/Signup";
//import { AddOrganizer } from '../components/AddOrganizer';


import SinglePageLayout from '../layouts/singlepagelayout';
//import { CreateEvent } from '../components/CreateEvent';
import { EventDetails } from '../components/EventDetails';
//import { EventJoin } from '../components/EventJoin';
import { UserList } from '../components/Admin/All-Users';
import { OrganizerList } from '../components/Admin/All-Organizers';
import { AllGames } from '../components/All-Games';
//import { EventConfirmation } from '../components/EventConfirmation';
import { BookedEvents } from '../components/BookedEvents';
import { AllEvents } from '../components/Admin/All Events';
import { UpcomingEvents } from '../components/UpcomingEvents';
import { Resources } from '../components/Resources';
import { AddCategory } from '../components/Admin/Categories';
import { UserProfile } from '../components/UserProfile';
import { Travel } from '../components/Travel';
import { Policy } from '../components/policy';
import { CreateTour } from '../components/Admin/CreateTour';
import { TourDetails } from '../components/Tour Details/index';
import { Referral } from '../components/Referral';
import { Contact } from '../components/Contact';
import { TourList } from '../components/Admin/All-Tours';
import { TourLead } from '../components/Admin/Tour Leads';
import { PartnerDetails } from '../components/PatnershipDetails';
import { TermsCondition } from '../components/terms';
import { OrganizerDetail } from '../components/Organizer-Details';
import { UpcomingSessions } from '../components/UpcomingSessions';
//import UserListPage from '../components/Admin/All-Users/all-users';
// import Sitemap from '../components/sitemap';




const Root = () => (
    <PnkProvider store={pnkstore}>
        {/* <BrowserRouter basename={process.env.PUBLIC_URL}> */}
            {/*<BrowserRouter basename='/'>*/}
            <Pnk_Error_Ctrl />
            <div>
                <Switch>
                    <Route exact path="/home"
                        render={(props) => (<SinglePageLayout children={HomeContainer} {...props} />)} />
                    <Route exact path="/"
                        render={(props) => (<SinglePageLayout children={HomeContainer} {...props} />)} />

                    <Route exact path="/session-details/:id?"
                        render={(props) => (<SinglePageLayout children={EventDetails} {...props} />)} />
                    <Route exact path="/organizers"
                        render={(props) => (<SinglePageLayout children={OrganizerList} {...props} />)} />
                    <Route exact path="/users"
                        render={(props) => (<SinglePageLayout children={UserList} {...props} />)} />
                    <Route exact path="/all-games"
                        render={(props) => (<SinglePageLayout children={AllGames} {...props} />)} />
                    <Route exact path="/booked-sessions"
                        render={(props) => (<SinglePageLayout children={BookedEvents} {...props} />)} />
                    <Route exact path="/sessions"
                        render={(props) => (<SinglePageLayout children={AllEvents} {...props} />)} />
                    <Route exact path="/upcoming-sessions"
                        render={(props) => (<SinglePageLayout children={UpcomingEvents} {...props} />)} />
                    <Route exact path="/user-profile/:id?"
                        render={(props) => (<SinglePageLayout children={UserProfile} {...props} />)} />
                    <Route exact path="/partner"
                        render={(props) => (<SinglePageLayout children={Resources} {...props} />)} />
                    <Route exact path="/partner-details"
                        render={(props) => (<SinglePageLayout children={PartnerDetails} {...props} />)} />
                    <Route exact path="/travel"
                        render={(props) => (<SinglePageLayout children={Travel} {...props} />)} />
                    <Route exact path="/tour-details/:id?"
                        render={(props) => (<SinglePageLayout children={TourDetails} {...props} />)} />
                    <Route exact path="/privacy-policy"
                        render={(props) => (<SinglePageLayout children={Policy} {...props} />)} />
                    <Route exact path="/terms-conditions"
                        render={(props) => (<SinglePageLayout children={TermsCondition} {...props} />)} />
                    <Route exact path="/refer-earn"
                        render={(props) => (<SinglePageLayout children={Referral} {...props} />)} />
                    <Route exact path="/contact"
                        render={(props) => (<SinglePageLayout children={Contact} {...props} />)} />
                    <Route exact path="/tours"
                        render={(props) => (<SinglePageLayout children={TourList} {...props} />)} />
                    <Route exact path="/tour-lead"
                        render={(props) => (<SinglePageLayout children={TourLead} {...props} />)} />
                    <Route exact path="/organizer-details/:id?"
                        render={(props) => (<SinglePageLayout children={OrganizerDetail} {...props} />)} />
                    <Route exact path="/upcoming-events"
                        render={(props) => (<SinglePageLayout children={UpcomingSessions} {...props} />)} />




                    <Route exact path="/login" component={LoginContainer} />
                    <Route exact path="/sign-up/:referral?" component={SignUpContainer} />

                    <Route exact path="/forgot-password" component={ForgotPasswordContainer} />
                    <Route exact path="/add-category" component={AddCategory} />
                    <Route exact path="/create-tour" component={CreateTour} />
                    {/* <Route path="/sitemap" component={Sitemap}></Route> */}
                    {/*<Route exact path="/add-organizer" component={AddOrganizer} />   */}
                    {/*  <Route exact path="/create-event" component={CreateEvent} /> */}
                    {/* <Route exact path="/join-event" component={EventJoin} />  */}
                    {/* <Route exact path="/event-confirmation" component={EventConfirmation} />   */}





                    {/* <Route exact path="/" component={LoginContainer} {...this.props} /> */}
                    {/* <Route exact path="/">
                        <LoginContainer />
                    </Route> */}
                    {/* <Route exact path="/login" component={LoginContainer} {...this.props} />
                    <Route exact path="/resetpassword/:link" component={ResetContainer} {...this.props} />
                    <Route exact path="/dashboard" render={(props) => (
                        sessionStorage.getItem('current_user_profile') != '' && sessionStorage.getItem('current_user_profile') != null ?
                            (sessionStorage.getItem('current_user_profile') == 'Sales' || sessionStorage.getItem('current_user_profile') == 'Sales TL' || sessionStorage.getItem('current_user_profile') == 'Sales Head') ?
                                <SinglePageLayout children={SalesDashboardPage} {...props} />
                                :
                                (sessionStorage.getItem('current_user_profile') == 'Administrator' || sessionStorage.getItem('current_user_profile') == 'CRM Admin' || sessionStorage.getItem('current_user_profile') == 'CRM Employee' || sessionStorage.getItem('current_user_profile') === 'temp_admin' || sessionStorage.getItem('current_user_name') === 'nikitarathore' || sessionStorage.getItem('current_user_name') === 'sahana' || sessionStorage.getItem('current_user_profile') === 'test_data') ?
                                    <SinglePageLayout children={AdminDashboardPage} {...props} />
                                    :
                                    (sessionStorage.getItem('current_user_profile') == 'Telecalling') ?
                                        <SinglePageLayout children={PreSalesDashboardPage} {...props} />
                                        :
                                        (sessionStorage.getItem('current_user_profile') == 'Marketing') ?
                                            <SinglePageLayout children={MarketingDashboardPage} {...props} />
                                            :
                                            (sessionStorage.getItem('current_user_profile') == 'Tele TL') ?
                                                <SinglePageLayout children={TeleTLDashboardPage} {...props} />
                                                :
                                                sessionStorage.getItem('current_user_profile') === 'Email_Marketing' ?
                                                    <SinglePageLayout children={ArchievePage} {...props} />
                                                    :
                                                    <SinglePageLayout children={DashboardPage} {...props} />

                            :

                            (localStorage.getItem('current_user_profile') == 'Sales' || localStorage.getItem('current_user_profile') == 'Sales TL' || localStorage.getItem('current_user_profile') == 'Sales Head') ?
                                <SinglePageLayout children={SalesDashboardPage} {...props} />
                                :
                                (localStorage.getItem('current_user_profile') == 'Administrator' || sessionStorage.getItem('current_user_profile') == 'CRM Admin' || sessionStorage.getItem('current_user_profile') == 'CRM Employee' || sessionStorage.getItem('current_user_profile') === 'temp_admin') ?
                                    <SinglePageLayout children={AdminDashboardPage} {...props} />
                                    :
                                    (sessionStorage.getItem('current_user_profile') == 'Telecalling') ?
                                        <SinglePageLayout children={PreSalesDashboardPage} {...props} />
                                        :
                                        (sessionStorage.getItem('current_user_profile') == 'Tele TL') ?
                                            <SinglePageLayout children={TeleTLDashboardPage} {...props} />
                                            :
                                            <SinglePageLayout children={DashboardPage} {...props} />
                    )} />

                 
                    {/******************** 404 Page-+ Route *********************/}
                    {/* <Route exact path="*" component={NotFound}/> */}
                </Switch>
                {/* <Route exact path="/purchase" component={BuyPage} /> */}
            </div>
        {/* </BrowserRouter> */}
    </PnkProvider>
)
Root.propTypes = {
    store: PropTypes.object.isRequired,
}
export default Root